import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Utility } from 'src/app/core/common';

@Component({
  selector: 'app-manual-payment-modal',
  templateUrl: './manual-payment-modal.component.html',
  styleUrls: ['./manual-payment-modal.component.scss']
})
export class ManualPaymentModalComponent implements OnInit {
  Utility = Utility;
  @Input() amount: number;
  @Output() submitPayment = new EventEmitter<string>(undefined);
  manualToken?: string;

  constructor(private store: Store) { }

  current: any;
  ngOnInit(): void {
    this.current = this.store.selectSnapshot(state => state.auth.user);
  }

  @ViewChild('manualModal') manualModal: NgxSmartModalComponent;
  open() {
    this.manualModal.open();
  }
  close() {
    this.manualModal.close();
  }
  pay() {
    if (this.manualToken)
      this.submitPayment.emit(this.manualToken);
  }
}
